<template>
  <div class="press--template page-transition z-content bg-beige">
    <div class="home-handle-overflow">

      <div class="relative pt4 bg-beige z-content">
        <div class="relative w-100 center container-fluid">
          <h1 class="mv0 is-navy is-blenny relative dib f-page-title ttu">{{ page.title }}</h1>
        </div>
      </div>

      <div class="relative bg-beige z-content pb5" v-if="isWindowWidthMobile == true">
        <section class="relative w-100 center pv4 is-black">
          <swiper :options="swiperOptions" ref="mySwiper">
            <swiper-slide>
              <div class="relative container-fluid">
                <div class="db w-100">
                  <img class="db relative center img-responsive w-100" :src="page.featured_content_section.featured_content['0'].image" :alt="page.featured_content_section.featured_content['0'].title"/>
                  <h3 class="f20px is-tablet-bold mt4 mb3 is-navy">{{ page.featured_content_section.featured_content['0'].title }}</h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">{{ page.featured_content_section.featured_content['0'].text }}</p>
                  <a class="f15px is-tablet-regular ttu is-red" title="Download" :href="page.featured_content_section.featured_content['0'].link">Download</a>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="relative container-fluid">
                <div class="db w-100">
                  <img class="db relative center img-responsive w-100" :src="page.featured_content_section.featured_content['1'].image" :alt="page.featured_content_section.featured_content['1'].title"/>
                  <h3 class="f20px is-tablet-bold mt4 mb3">{{ page.featured_content_section.featured_content['1'].title }}</h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">{{ page.featured_content_section.featured_content['1'].text }}</p>
                  <a class="f15px is-tablet-regular ttu is-red" title="Download" :href="page.featured_content_section.featured_content['1'].link">Download</a>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="relative container-fluid">
                <div class="db w-100">
                  <img class="db relative center img-responsive w-100":src="page.featured_content_section.featured_content['2'].image" :alt="page.featured_content_section.featured_content['2'].title"/>
                  <h3 class="f20px is-tablet-bold mt4 mb3">{{ page.featured_content_section.featured_content['2'].title }}</h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">{{ page.featured_content_section.featured_content['2'].text }}</p>
                  <a class="f15px is-tablet-regular ttu is-red" title="Download" :href="page.featured_content_section.featured_content['2'].link">Download</a>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </section>
      </div>

      <div class="relative bg-beige z-content" v-if="isWindowWidthMobile == false">
        <div class="relative container-fluid">
          <section class="relative center mw9 is-black">
            <div class="row pb5">
              <div class="col-xs-12 col-sm-4 pb4">
                <div class="w-80">
                  <img class="db relative center img-responsive w-100" :src="page.featured_content_section.featured_content['0'].image" :alt="page.featured_content_section.featured_content['0'].title"/>
                  <h3 class="f20px is-tablet-bold is-navy mt4 mb3">{{ page.featured_content_section.featured_content['0'].title }}</h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">{{ page.featured_content_section.featured_content['0'].text }}</p>
                  <a class="f15px is-tablet-regular ttu is-red" title="Download" :href="page.featured_content_section.featured_content['0'].link">Download</a>
                </div>
              </div>
              <div class="col-xs-12 col-sm-4 border-3-col">
                <div class="w-80 center">
                  <img class="db relative center img-responsive w-100" :src="page.featured_content_section.featured_content['1'].image" :alt="page.featured_content_section.featured_content['1'].title"/>
                  <h3 class="f20px is-tablet-bold mt4 mb3 is-navy">{{ page.featured_content_section.featured_content['1'].title }}</h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">{{ page.featured_content_section.featured_content['1'].text }}</p>
                  <a class="f15px is-tablet-regular ttu is-red" title="Download" :href="page.featured_content_section.featured_content['1'].link">Download</a>
                </div>
              </div>

              <div class="col-xs-12 col-sm-4 pb4">
                <div class="w-80 fr">
                  <img class="db relative center img-responsive w-100" :src="page.featured_content_section.featured_content['2'].image" :alt="page.featured_content_section.featured_content['2'].title"/>
                  <h3 class="f20px is-tablet-bold mt4 mb3 is-navy">{{ page.featured_content_section.featured_content['2'].title }}</h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">{{ page.featured_content_section.featured_content['2'].text }}</p>
                  <a class="f15px is-tablet-regular ttu is-red" title="Download" :href="page.featured_content_section.featured_content['2'].link">Download</a>
                </div>
              </div>
              
            </div>
          </section>
        </div>
      </div>

      <div class="db relative">
        <div class="relative container-fluid">
          <section class="relative mw8 center mb3 is-black pb5 tc">
            <div class="page-template cms-content" v-if="page.section_two.text" v-html="marked(page.section_two.text)">
            </div>
            <div class="" v-else>
              {{ page.section_two.text }}
            </div>
          </section>
        </div>
      </div>

      <!--<fixedbg :background="'/uploads/home-slider-optim.jpg'">
        <template slot="contents">
          <accolades-swiper  height="585px"></accolades-swiper>
        </template>
      </fixedbg>-->



      <div class="dn relative bg-cream z-content">
          <div class="relative container-fluid">
            <section class="relative center mw8-5 is-black">
              <div class="row pv5">
                
                <div class="col-xs-12 col-sm-4 pb4">
                  <div class="w-80-ns">
                    <h3 class="f20px is-tablet-bold mt4 mb3">{{ page.bottom_content_section.content_blocks['0'].title }}</h3>
                    <a class="f15px is-tablet-bold pointer" title="Download" :href="page.bottom_content_section.content_blocks['0'].link">Download</a>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-4 pb4">
                <div class="w-80-ns center-ns">
                  <h3 class="f20px is-tablet-bold mt4 mb3">{{ page.bottom_content_section.content_blocks['1'].title }}</h3>
                  <div class="f15px is-tablet-regular lh-copy link-bold" v-html="marked(page.bottom_content_section.content_blocks['1'].text)"></div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-4 pb4">
                  <div class="w-80-ns fr-ns">
                    <h3 class="f20px is-tablet-bold mt4 mb3">{{ page.bottom_content_section.content_blocks['2'].title }}</h3>
                    <div class="f15px is-tablet-bold" v-html="marked(page.bottom_content_section.content_blocks['2'].text)"></div>
                  </div>
                </div>
                
              </div>
            </section>
          </div>
        </div>
      
    </div>
  </div>
</template>

<script>
import AccoladesSwiper from './accolades-swiper.vue';
import Fixedbg from './fixedbg.vue';
export default {
  components: {
    AccoladesSwiper,
    Fixedbg
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk}` : '';
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      appIsLoaded: true,
      logoIsLoaded: false,
      isWindowWidthMobile: false,
      parallax:null,
      window: {
        width: 0,
        height: 0
      },
      swiperOptions: {
          autoplay: {
            delay: 7000,
          },
          speed: 800,
          autoplayDisableOnInteraction: false,
          // loop: true,
          initialSlide: 0,
          //pagination: '.swiper-pagination',
          paginationClickable: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: false,
          },
          keyboardControl: true,
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev'
          // },
          initialSlide: 0,
          spaceBetween: 15,
          freeMode: false,
          slidesPerView: 1.3,
        }
      }
    },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('press.markdown');
      console.log(pageData[0]);
      return pageData[0];
    },
    swiper() {
      if(this.$refs.mySwiper)
        return this.$refs.mySwiper.swiper
    },
  },
  methods: {
    // scrollParallax: function(){
    //   this.parallax = window.scrollY;
    //   if(this.swiper)
    //     this.swiper.update();
    // },
    // calcParallax: function(myTarget, offset, movement, positioning){
    //   if(this.$refs[myTarget]){
    //     if((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + this.$refs[myTarget].getBoundingClientRect().height) + movement > 0 && (this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset) - movement  < window.innerHeight){
    //       var newMovement = offset + (((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + (this.$refs[myTarget].getBoundingClientRect().height / 2) - (window.innerHeight / 2) - 27) / window.innerHeight) * movement);
    //       return 'top:'+newMovement+'px;'+positioning;
    //     } else {
    //       return 'display:none;';
    //     }
    //   }
    // }
    mobileDesktop() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768)
        this.isWindowWidthMobile = true; 
      else{
        this.isWindowWidthMobile = false; 
      }
      if(this.swiper)
        this.swiper.update();
    },
  },
  created() {
    var w = window.innerWidth;
    if (w < 768) {
      this.isWindowWidthMobile = true; 
    }
    else {
      this.isWindowWidthMobile = false; 
    }
    window.addEventListener('resize', this.mobileDesktop);
    window.addEventListener('scroll', this.mobileDesktop);
    window.addEventListener('load', this.mobileDesktop);
  },
  mounted() {
  },
  destroyed() {
    window.removeEventListener('resize', this.mobileDesktop);
    window.removeEventListener('scroll', this.mobileDesktop);
    window.removeEventListener('load', this.mobileDesktop);
  },
}
</script>
